import React from 'react';

const ThreeDotsVertical = ({
    color = "#343330"
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M12.5 16.8945C11.6716 16.8945 11 17.5661 11 18.3945C11 19.223 11.6716 19.8945 12.5 19.8945C13.3284 19.8945 14 19.223 14 18.3945C14 17.5661 13.3284 16.8945 12.5 16.8945Z" fill={color} />
            <path d="M12.5 10.5195C11.6716 10.5195 11 11.1911 11 12.0195C11 12.848 11.6716 13.5195 12.5 13.5195C13.3284 13.5195 14 12.848 14 12.0195C14 11.1911 13.3284 10.5195 12.5 10.5195Z" fill={color} />
            <path d="M12.5 4.14453C11.6716 4.14453 11 4.8161 11 5.64453C11 6.47296 11.6716 7.14453 12.5 7.14453C13.3284 7.14453 14 6.47296 14 5.64453C14 4.8161 13.3284 4.14453 12.5 4.14453Z" fill={color} />
        </svg>
    );
}

export default ThreeDotsVertical;